import { render } from "./TableFooter.vue?vue&type=template&id=78184031&scoped=true"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"

import "./TableFooter.vue?vue&type=style&index=0&id=78184031&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78184031"]])

export default __exports__